import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import sec03_alphabet01_m from '../../../../resources/img/Events/Marketing/sec03_alphabet01_m.png';
import sec03_alphabet02_m from '../../../../resources/img/Events/Marketing/sec03_alphabet02_m.png';

export const Section03to05 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec03_05} ${styles.rel}`}>
                <div className={styles.sec03_05__fontWrap}>
                    <animated.p className={`${styles.sec03_05__fontWrap__font01} ${styles.notoBold} ${styles.ab} ${styles.marginDel}`} style={{
                        opacity: spring.x.to({
                            range: [0, 0.8, 0.95, 1],
                            output: [1, 1, 0, 0]
                        }).to(x => x),
                        translateY: spring.x.to({
                            range: [0, 0.15, 0.8, 0.95, 1],
                            output: [15, 0, 0, -9, -9]
                        }).to(x => `${x}vh`)
                    }}>거래</animated.p>
                    <animated.p className={`${styles.sec03_05__fontWrap__font02} ${styles.notoBold} ${styles.ab} ${styles.marginDel}`} style={{
                        opacity: spring.x.to({
                            range: [0.95, 1.1, 1.9, 2.05],
                            output: [0, 1, 1, 0]
                        }).to(x => x),
                        translateY: spring.x.to({
                            range: [0.95, 1.1, 1.9, 2.05],
                            output: [9, 0, 0, -9]
                        }).to(x => `${x}vh`)
                    }}>참여</animated.p>
                    <animated.p className={`${styles.sec03_05__fontWrap__font03} ${styles.notoBold} ${styles.ab} ${styles.marginDel}`} style={{
                        opacity: spring.x.to({
                            range: [2.05, 2.2, 3],
                            output: [0, 1, 1]
                        }).to(x => x),
                        translateY: spring.x.to({
                            range: [2.05, 2.2, 2.85, 3],
                            output: [9, 0, 0, -15]
                        }).to(x => `${x}vh`)
                    }}>사용</animated.p>
                    <animated.p className={`${styles.sec03_05__fontWrap__font04} ${styles.notoBold} ${styles.ab} ${styles.marginDel}`} style={{
                        translateY: spring.x.to({
                            range: [0, 0.15, 2.85, 3],
                            output: [15, 0, 0, -15]
                        }).to(x => `${x}vh`)
                    }}>할 때</animated.p>
                </div>
                <animated.img className={`${styles.sec03_05__img01} ${styles.ab}`} src={sec03_alphabet01_m} alt="알파벳 묶음1" style={{
                    translateY: spring.x.to({
                        range: [0, 0.15, 2.85, 3],
                        output: [-30, 0, 0, -30]
                    }).to(x => `${x}vh`)
                }} />
                <animated.img className={`${styles.sec03_05__img02} ${styles.ab}`} src={sec03_alphabet02_m} alt="알파벳 묶음2" style={{
                    translateY: spring.x.to({
                        range: [0, 0.15, 2.85, 3],
                        output: [30, 0, 0, -30]
                    }).to(x => `${x}vh`)
                }} />
            </div>
        </animated.div>
    )
}